<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column  mu-w-100">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Group hierarchies</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group">
                        <router-link :to="CONTEXT_PATH + '/usersgroups/hierarchies/new'">
                            <button class="mcc-button mcc-button--primary" id="addGrpHierarchyBtn" title="Add group hierarchy">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add group hierarchy</span>
                            </button>
                        </router-link>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" class="">
                <ol class="mcc-breadcrumb">
                    <li>Users & groups</li>
                    <li>Hierarchies</li>
                </ol>
            </nav>
        </div>
        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitDialog" title="Group Hierarchy Filters">
            <section>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <form id="formIdd">
                        <div>
                            <div class="mfc-input-wrapper mfc-form-input-container">
                                <label for="hierarchyName">Hierarchy name</label>
                                <input type="text" name="hierarchyName" maxlength="50" id="hierarchyName" :pattern="nameRegex" :value="hierarchyNameRef" @change="hierarchyNameRef = $event.target.value">
                            </div>
                            <div class="mfc-slim-select-wrapper drawer-input mu-position-relative dialogSlimSelect">
                                <label for="selectPage" class="mu-mb-00">Group</label>
                                <select @change="groupsRef = $event.target.value" ref="groupRefEle" id="groupRefEle" name="groupId" block label="Group" multiple>
                                    <!-- <option v-for="(group,key) in groups" :key="key" :value="group.id">{{group.name}}</option> -->
                                </select>
                            </div>
                            <div class="mcc-segmented-buttons mcc-segmented-buttons--sm drawer-input">
                                <fieldset class="mfc-fieldset">
                                    <legend class="mfc-label">
                                        Disabled
                                    </legend>
                                    <div class="mcc-segmented-buttons__list" label="Status" block ref="disabledRadioRef" name="disabled-radioGroup" id="disabled-radioGroup">
                                        <input type="checkbox" name="not-started" value="yes" id="not-started" @click="disabledRef = $event.target.value" :checked="disabledRef == 'yes'">
                                        <label class="mcc-segmented-buttons__button" for="not-started">
                                            <span class="mcc-segmented-buttons__label">Yes</span>
                                        </label>
                                        <input type="checkbox" name="pending" value="no" id="pending" @click="disabledRef = $event.target.value" :checked="disabledRef == 'no'">
                                        <label class="mcc-segmented-buttons__button" for="pending">
                                            <span class="mcc-segmented-buttons__label">No</span>
                                        </label>
                                        <input type="checkbox" name="in-progress" value="all" id="in-progress" @click="disabledRef = $event.target.value" :checked="disabledRef == 'all'">
                                        <label class="mcc-segmented-buttons__button" for="in-progress">
                                            <span class="mcc-segmented-buttons__label">All</span>
                                        </label>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </Drawer>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="mcc-card">
                        
                        <div class="mcc-card__body">
                            <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()">
                                    <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Filters{{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                                </button>
                            </div>
                            <mcc-data-table ref="hierarchyTable" id="hierarchyTableId"></mcc-data-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import HierarchyAPI from "../../../services/HierarchyAPI";
import Drawer from '../../common/Drawer.vue';
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "GroupHierarchyList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["usersgroups.hierarchies.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            groupHierarchies: {},
            groups: {},
            updateDialog: false,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            hierarchyNameRef: "",
            hierarchyName: "",
            disabledType: "no",
            disabledRef: "no",
            groupsRef: "",
            groupIds: "",
            selectInstanceEntities: null,
            tableData: [],
            filterActive: false,
            filterData: [],
            filterCount: 0,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        var self = this;
        if (this.$route.query.groupId) {
            let group = this.$route.query.groupId;
            if (group != "" && group != null) {
                this.groupIds = group.split(",");
                this.groupsRef = group.split(",");
                this.disabledType = "all";
                this.disabledRef = "all";
            }
        } else if (localStorage.getItem("GroupHierarchyList") === "GroupHierarchyList") {
            var storedName = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_hierarchyName");
            if (storedName != null && storedName != "") {
                this.hierarchyName = storedName;
                this.hierarchyNameRef = storedName;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_hierarchyName"
            );
            var storedIds = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_groupIds"
            );
            if (storedIds != null && storedIds != "") {
                this.groupIds = storedIds.split(",");
                this.groupsRef = storedIds.split(",");
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_groupIds"
            );

            var storedDisableType = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_disabledType"
            );
            if (storedDisableType != null && storedDisableType != "") {
                this.disabledType = storedDisableType;
                this.disabledRef = storedDisableType;
            }
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_disabledType"
            );
            var storedPageSize = localStorage.getItem("groupHierarchyListPageSize");
            if (storedPageSize != null && storedPageSize != "") {
                this.currentPageSize = parseInt(
                    storedPageSize
                );
            }
            localStorage.removeItem("groupHierarchyListPageSize");

            localStorage.removeItem("GroupHierarchyList");

            this.filterCount = parseInt(
                localStorage.getItem("GroupHierarchyListCount")
            );
            localStorage.removeItem("GroupHierarchyListCount");
        }
        this.initHierarchyTable();
        if (this.$refs.hierarchyTable.isReady) {
            this.initHierarchyTable();
        } else {
            this.$refs.hierarchyTable.addEventListener("ready", function () {
                self.initHierarchyTable();
            });
        }

        this.selectInstanceEntities = new SlimSelect({
            select: '#groupRefEle',
            settings: {
            closeOnSelect: false,
            },
        })
        HierarchyAPI.getAllNonDeletedGroups().then(result => {
            let optionsArr = []
            let option;
            result.forEach(group => {
                option = {
                    text: group.name,
                    value: group.id
                }
                optionsArr.push(option);
            })
            this.selectInstanceEntities.setData(optionsArr)
            self.groups = result;
        });
    },
    methods: {
        getFilterCount() {
            if (this.hierarchyNameRef != "")
                this.filterCount += 1
            if (this.groupsRef != "")
                this.filterCount += 1
            if (this.disabledRef != "")
                this.filterCount += 1

        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.hierarchyName = this.hierarchyNameRef;
            this.groupIds = this.selectInstanceEntities.getSelected();
            this.disabledType = this.disabledRef;
            this.filterCount = 0;
            this.getFilterCount();
            this.initHierarchyTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        closeDialog() {
            this.updateDialog = false;
        },
        async updateMultiselect() {
            await this.$nextTick();
            this.$refs.groupRefEle.value = this.groupsRef;
        },
        showDialog() {
            this.updateDialog = true;
            this.updateMultiselect();
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        resetFilter() {
            this.updateCall = false;
            this.hierarchyName = "";
            this.hierarchyNameRef = "";
            this.disabledType = "no";
            this.disabledRef = "no";
            this.groupsRef = "";
            this.groupIds = "";
            this.filterCount = 0;
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.selectInstanceEntities.setSelected('')
            this.initHierarchyTable();
        },
        updateTemplate() {
            var self = this;
            this.$refs.hierarchyTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        var targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            this.$router.push(
                                this.CONTEXT_PATH + '/usersgroups/hierarchies/' + $(targetEle).attr("data-id")
                            );
                        }
                    });
                });

            $(".groupsLink").each((a, obj) => {
                var id = $(obj).attr("name");
                var numberOfGroups = $(obj)[0].innerText;
                var isDeleted = $(obj).attr("data-disable");
                let htmlTag = "";
                if (parseInt(numberOfGroups) > 0 && isDeleted != "Yes") {
                    htmlTag +=
                        '<a class="table-link">' +
                        numberOfGroups +
                        "</a>";
                    obj.addEventListener("click", e => {
                        self.$router.push({
                            path: self.CONTEXT_PATH + "/usersgroups/groups",
                            query: {
                                hierarchyId: id
                            }
                        });
                    });
                } else {
                    htmlTag +=
                        "<span>" +
                        numberOfGroups +
                        "</span>";
                }
                $(obj).html(htmlTag);
            });

        },
        initHierarchyTable() {
            var self = this;

            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("hierarchyTableId"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No group hierarchies found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true,
                            columnSearch: false
                        },
                        numberOfGroups: {
                            type: "string",
                            title: "Number of groups",
                            template: '<div class="groupsLink" data-disable="{{isDisabled}}" name="{{id}}">{{numberOfGroups}}<div>',
                            sortable: false,
                            columnSearch: false
                        },
                        isDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name";
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc";
                        }
                        var disabledYes = self.disabledType == "yes" || self.disabledType == "all";
                        var disabledNo = self.disabledType == "no" || self.disabledType == "all";
                        var queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&hierarchyName=" +
                            self.hierarchyName +
                            "&cYes=" +
                            disabledYes +
                            "&cNo=" +
                            disabledNo;
                        return HierarchyAPI.getGroupHierarchies(queryString, self.groupIds).then(result => {
                            var responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCall = true;

                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("groupHierarchyListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_hierarchyName",
                this.hierarchyName
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_groupIds",
                this.groupIds
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_disabledType",
                this.disabledType
            );
            localStorage.setItem("GroupHierarchyListCount", this.filterCount);
        }
    }
};
</script>

<style scoped>
</style>
